import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import Link from "../components/Link";
import Header from '../components/Header';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import AlertInformation from '../components/AlertInformation';

const ContentContainer = styled.div`
  margin: 0 auto;
  max-width: 800px;
  padding: 1rem;

  @media (min-width: 480px) {
    padding: 1rem 2rem;
  }
`;

class Layout extends React.Component {

  constructor(props) {
    super(props);
    this.state = { navAboutOpen: false };
    this.handleToggleNav = this.handleToggleNav.bind(this);
    this.handleCloseNav = this.handleCloseNav.bind(this);
  }

  handleToggleNav() {
    this.setState(curr => {
      return {
        navAboutOpen: !curr.navAboutOpen
      };
    });
  }

  handleCloseNav() {
    this.setState(() => ({ navAboutOpen: false }))
  }

  renderCovidWarning () {
    if (this.props.location.pathname !== '/covid') {
      return (
        <AlertInformation>
          <Link to="/covid">COVID-19 Update</Link>
        </AlertInformation>
      )
    }
  }

  render() {

    const { children, data } = this.props;
    const { title, contactDetails } = data.site.siteMetadata;

    return (
      <div>
        <Helmet
          title={title}
          meta={[
            { name: 'description', content: 'The website for Ian Willmott, the Bristol based McTimoney Chiropractor.' },
            { name: 'keywords', content: 'bristol, chiropractor, chiropractic' },
          ]}
        />
        <Header siteTitle={title} />
        <NavBar onToggleNav={this.handleToggleNav} onCloseNav={this.handleCloseNav} aboutOpen={this.state.navAboutOpen} />
        <ContentContainer onClick={this.handleCloseNav} >
          {this.renderCovidWarning()}
          {children()}
        </ContentContainer>
        <Footer contactDetails={ contactDetails } />
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        contactDetails {
          address
          telephoneNumber
          emailAddress
          socialMedia {
            twitter
            facebook
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js